module.exports = __webpack_public_path__ + "media/images/forms-icons/temprature-icon-hover-fd38c4be0fe9854a1af3f021c57f4442.svg";